export default __webpack_public_path__ + "static/media/11a.48f7bf1f.png";